import { createSelector } from 'reselect';
import CompliancePredesDestinationImpcCodeNotRegisteredSummaryColumns
  from '../../containers/CompliancePredesDestinationImpcCodeNotRegisteredSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, CompliancePredesDestinationImpcCodeNotRegisteredSummaryColumns);
